import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSessionStorage } from "react-use";
import { CustomerInfoExpander } from "../../CustomerInfoExpander/CustomerInfoExpander";
import { IconCustomerInfo } from "shared/icons/IconCustomerInfo";
import { InfoView } from "./InfoView/InfoView";
import { InfoEdit } from "./InfoEdit/InfoEdit";
import { useInfoData } from "./useInfoData";

/**
 * {
          street: "Street",
          city: "City",
          state: "State",
          zip: "Zip",
          clientNumber: "ClientNumber",
          occupation: "Occupation",
          birthday: "Birthday",
          spouse: "Spouse",
          anniversary: "Anniversary",
          dittoStartDate: "DittoStartDate",
          preferredDeliveryMethod: "PreferredDeliveryMethod",
          gateCode: "GateCode",
          dropOffLocation: "DropOffLocation",
          dietaryPreferences: "DietaryPreferences",
          allergies: "Allergies",
          healthConcerns: "HealthConcerns",
        }
 */

export function Info({ contact }) {
  const { t } = useTranslation();
  const data = useInfoData(contact.id);
  const [isOpen, setIsOpen] = useSessionStorage("customer-info-open", false);
  const [isEditing, setIsEditing] = useState(false);
  const [editDisabled, setEditDisabled] = useState(false);

  // console.log(data);

  return (
    <CustomerInfoExpander
      isOpen={isOpen}
      onToggle={setIsOpen}
      icon={<IconCustomerInfo width={24} height={24} />}
      title={t("sectionHeaders.customerInfo")}
      color="#445363"
    >
      {data.isLoading ? (
        "Loading..."
      ) : (
        <>
          {isEditing ? (
            <InfoEdit
              info={data.data || {}}
              onSave={(saved) => {
                setEditDisabled(true);
                data.saveMutation
                  .mutateAsync(saved)
                  .then(() => {
                    setIsEditing(false);
                  })
                  .catch((err) => {
                    console.error(err);
                  })
                  .finally(() => {
                    setEditDisabled(false);
                  });
              }}
              onCancel={() => {
                setIsEditing(false);
              }}
            />
          ) : (
            <InfoView
              info={data.data || {}}
              onEdit={() => {
                setIsEditing(true);
              }}
            />
          )}
        </>
      )}
    </CustomerInfoExpander>
  );
}
